// @flow
import $ from 'jquery';
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';

// app/javascript/application/views/company/stock_options/forms/TermAndConditionsView.js を参考にしてます
export default class StockOptionInput extends JQueryView {
  establishAt: string;

  constructor(establishAt: string) {
    super('.simple_form');

    this.establishAt = establishAt;
    this.initDateRangePicker(this.$el);
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        minDate: this.establishAt,
        showDropdowns: true,
        locale: {
          format: 'Y/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'Y/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: any) {
    event.preventDefault();
    $(event.target)
      .prev('input[type=hidden]')
      .val('1');
    $(event.target)
      .closest('fieldset')
      .remove();
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $(event.target).before(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );
  }

  @on({ event: 'change', selector: '.select-so_condition_category' })
  async onChangeConditionCategory(event: any) {
    const target = event.target;
    const categoryElementId = target.id;
    const soConditionCategoryId = target.value;

    var inputText = '';

    if (soConditionCategoryId) {
      const res = await this.getSoConditionCategory(soConditionCategoryId);
      inputText = res['detail'];
    }

    // .select-so_condition_categoryと連動して追加されるdetailのformのidを算出
    const detailElementId = categoryElementId.replace(
      'so_condition_category_id',
      'detail',
    );
    const detailElement = $(`#${detailElementId}`);
    detailElement.val(inputText);
    // 自動補完が行われるのでエラー状態をリセット
    detailElement.removeClass('is-invalid');
    removeInvalidFeedback(detailElement);
    detailElement.removeClass('focus');
  }

  // SO管理のAPIを間借りしてます
  async getSoConditionCategory(soConditionCategoryId: number) {
    const res = await $.ajax({
      url: `/company/share_type_so_exercise_condition_categories/${soConditionCategoryId}`,
      type: 'GET',
    });

    return res;
  }

  // バリデーションエラーがあった項目で入力すればスタイルをリセットする
  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  // 日付のバリデーションエラーがあった項目で入力すればスタイルをリセットする
  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field1') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  // チェックボックスのバリデーションエラーがあった項目で入力すればスタイルをリセットする
  @on({
    event: 'change',
    selector:
      'input[name="company_procedure_stock_option_form[share_type_attributes][so_category_ids][]"]',
  })
  onChangeSoCategoryIds(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      removeInvalidFeedback(target);
    }
  }
}
